import { useMemo } from "react";
import moment from "moment-timezone";
import { Dialog } from "@shared/ui/Dialog";
import { ProgramCircleParticipant } from "../ProgramCircleParticipants/ProgramCircleParticipant";
import { Loader } from "@shared/ui/Loader";
import { Circle, Meeting } from "@platform/types/platform.types";
import { TimezoneOption } from "@platform/features/timezones/timezones.types";

export type Props = {
  circle?: Circle;
  isOpen: boolean;
  onClose: () => void;
  userTimezoneOption: TimezoneOption;
};

export function ProgramMeetingInformationDialog({
  circle,
  isOpen = true,
  onClose,
  userTimezoneOption,
}: Props) {
  const meeting = circle?.meetings.find(
    (meeting) => meeting.isSelected
  ) as Meeting;

  if (!meeting) return null;
  if (!userTimezoneOption) return null;

  const meetingStartTime = useMemo(() => {
    return moment(meeting.start_time).isValid()
      ? moment(meeting.start_time)
          .tz(userTimezoneOption.name)
          .format("MMM Do h:mma z")
      : null;
  }, [meeting.start_time, userTimezoneOption]);

  return (
    <Dialog
      title={meeting?.title || "Meeting Information"}
      description={`Scheduled for ${meetingStartTime}`}
      isOpen={isOpen}
      onClose={onClose}
      containerClassName="gap-0"
      className="p-0 md:p-0"
      size="4xl"
    >
      {meeting ? (
        <div className="flex flex-row flex-wrap w-full">
          {meeting.participants?.map((participant) => (
            <ProgramCircleParticipant
              key={participant.user.id}
              participant={participant.user}
              participantRole={
                meeting.participants?.find(
                  (p) => p.user.id === participant.user.id
                )?.role
              }
              className="basis-full md:basis-1/2"
              isWithBio={false}
              isWithEditButton={false}
              isWithWebsite={false}
            />
          ))}
        </div>
      ) : (
        <Loader isAbsolute />
      )}
    </Dialog>
  );
}

export default ProgramMeetingInformationDialog;
